import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import queryString from 'query-string';
import { get, some, isEmpty } from 'lodash-es';
import styled from 'styled-components';
import {
  BaseBox,
  FlexBox,
  CenterBox,
  Heading3,
  Heading4,
  Body2,
  Icons,
  PrimaryButton,
} from '@docon/docon-ui-library';
import {
  Content,
  ActionLists,
  Footer,
  Modal,
} from './detailsElements';
import CancelAppointment from './CancelAppointment';
import AppointmentCard from 'components/Appointment/components/Card';
import OrderMedicine from 'components/Records/OrderMedicine';
import Prescription from 'components/Records/Prescription';
import BookAppointmentModal from 'components/BookAppointment';
import DocItem from 'components/Doctors/DocItem';
import { getAppointment, getProfileToken, getReceipt, updateAppointmentState } from 'redux/reducer/appointment';
import { getShifts } from 'redux/reducer/shift';
import { updateAgoraState } from 'redux/reducer/agora';
import { colors } from 'utilities/colorConfig';
import Map from 'shared/Map';
import { Loader, GetDirection, AlertMsg } from 'shared';
import { Share, Cancel, VideoChat, Reschedule, TimeIcon } from 'shared/icons';
import { cleverTapAnl } from 'utilities';
import { getAddressString, getDelayTimeFromMinutes, getTimeFromMinutes } from 'utils';
import { EventAppointmentReschedule, EventBookFollowup, EventDoctorSelect } from 'utilities/clevertapEvent';
import { emitEvent, isPeIosWebview } from 'utils/webview/webview';
import { useCookies } from 'react-cookie';
import { cookieNames, mediaPermissionsStatusMapping } from 'utils/constants';
import { checkMediaPermissions, getMediaPermissions } from 'utils/common';

const PrescriptionModal = styled(Prescription)`
  animation: none;
`;

const BookingModal = styled(BookAppointmentModal)`
  animation: none;
`;

const actionListsByStatus = {
  cancelled: [
    { id: 'rebookAppointment', label: 'Rebook Appointment', Icon: Reschedule },
  ],
  notCancelled: [
    { id: 'joinCall', label: 'Join video call', checkKey: 'isTeleConsult', Icon: VideoChat },
    { id: 'toCalendar', label: 'Add to calendar', Icon: Icons.CalenderIcon },
    { id: 'reschedule', label: 'Reschedule', Icon: Reschedule },
    { id: 'cancelAppointment', label: 'Cancel appointment', color: colors.error, Icon: Cancel },
  ],
};

const calenderUrl = 'http://www.google.com/calendar/event?';
function AppointmentDetails({
  appointmentId,
  appointmentDate,
  appointmentStatus = '',
  parseAppointmentTime,
  doctorID,
  clinicID,
  history,
  onClose,
  source,
  ...props
}: any) {

  const {
    appointment,
    bookedAppointment,
    token,
    receipt,
    isFetchingReceipt,
    isFetchingAppointment,
    appointmentErrors,
  } = useSelector(state => state.appointment);

  const {
    shifts, isFetchingShifts,
  } = useSelector(state => state.shift);

  const dispatch = useDispatch();
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openBookingModal, setOpenBookingModal] = useState<any>(false);
  const [isReschedule, setIsReschedule] = useState<any>(false);
  const [openPrescriptionModal, setOpenPrescriptionModal] = useState(false);
  const [cookies, setCookies] = useCookies([cookieNames.VENDOR_COOKIE]);
  const isPharmeasyIosWebview = isPeIosWebview(cookies[cookieNames.VENDOR_COOKIE], navigator?.userAgent);
  const [showPermissionErrorToast, setShowPermissionErrorToast] = useState(false);

  useEffect(() => {
    if (!isFetchingAppointment)
      dispatch(getAppointment({ appointmentId }));
    if (!isFetchingShifts && isPastAppointment)
      dispatch(getShifts({ doctorID, clinicID }));
    if (!isPastAppointment)
      dispatch(getProfileToken(appointmentId));

    return () => {
      dispatch(updateAppointmentState({
        appointment: {},
        token: {},
        receipt: {},
        appointmentErrors: {},
        isAppointmentCanceled: false,
      }));
    };
  }, []);

  useEffect(() => {
    if (receipt.url)
      window.open(receipt.url);
  }, [receipt]);

  const {
    patientDetails: {
      firstName: pFirstName = '',
      lastName: pLastName = '',
      mobileNumber: pMobileNumber = null,
      officeID = '',
    } = {},
    tmpUserDetails: {
      firstName: tmpUFirstName = '',
      lastName: tmpULastName = '',
    } = {},
    doctordetails: {
      firstName: dFirstName = '',
      lastName: dLastName = '',
      shortUrl: docShortUrl = '',
    } = {},
    userDetails: {
      firstName: uFirstName = '',
      lastName: uLastName = '',
    } = {},
    clinicdetails: {
      name: clinicName = '',
      number: clinicNumber = null,
      address: clinicAddress = {},
    } = {},
    visitID,
    visitType,
    teleConsultSessionID,
    appointmentTime,
    delay: appointmentDelay = 0,
  } = appointment || {};

  const a = moment(appointment.appointmentDisplayTime || appointmentDate, 'YYYY-MM-DD HH:mm:ss ZZ');
  const b = moment();
  const timeDifferenceToAppointment = a.diff(b, 'days');
  let isPastAppointment = true;
  if (
    timeDifferenceToAppointment > -1 &&
    appointmentStatus !== 'cancelled' &&
    appointmentStatus !== 'completed' &&
    appointmentStatus !== 'noshow'
  ) {
    isPastAppointment = false;
  }

  const address = getAddressString(clinicAddress);
  const delayTime = getDelayTimeFromMinutes(appointmentDelay || 0);
  const patientFullName = `${pFirstName || ''} ${pLastName || ''}`;
  const userFullName = `${uFirstName || ''} ${uLastName || ''}`;
  const docFullName = `${dFirstName || ''} ${dLastName || ''}`;
  const tmpUserFullName = `${tmpUFirstName || ''} ${tmpULastName || ''}`;

  function openDoctorProfile() {
    if (!docShortUrl) { return; }

    cleverTapAnl.event({
      event_name: 'doctor_select',
      event: {
        page_name: 'appointments',
        is_search_active: false,
        doctor_id: doctorID,
        search_term: '',
        rank: 1,
      },
    } as EventDoctorSelect);

    history.push({
      pathname: `/doctors/${docShortUrl}`,
      search: location.search,
    });

  }

  function rebookAppointment() {
    cleverTapAnl.event({
      event_name: 'book_followup',
      event: {
        page_name: 'appointments',
        doctor_id: doctorID,
        visit_id: visitID,
        home_page_card_type: '-',
      },
    } as EventBookFollowup);
    setOpenBookingModal(true);
  }

  function getCalenderUrl() {
    const date = appointment.appointmentDisplayTime || appointmentDate;
    const isoS = moment(date).format('YYYYMMDDTHHmmSS');
    const isoE = moment(date).add(30, 'minutes').format('YYYYMMDDTHHmmSS');

    const params = {
      action: 'TEMPLATE',
      text: `Appointment with Dr. ${docFullName}`,
      location: address,
      details: 'For Cosultation/follow-up',
      dates: `${isoS}/${isoE}`,
    };
    return `${calenderUrl}${queryString.stringify(params)}`;
  }

  const checkAndSetPermission = async () => {
    const mediaPermissionsStatus = await checkMediaPermissions();
    if (mediaPermissionsStatus === mediaPermissionsStatusMapping.GRANTED) {
      getMediaPermissions();
    } else if (mediaPermissionsStatus === mediaPermissionsStatusMapping.DENIED) {
      setShowPermissionErrorToast(true);
      setTimeout(() => {
        setShowPermissionErrorToast(false);
      }, 4000);
    }
  };

  function handleClick(event: any) {
    event.stopPropagation();
    const id = event?.currentTarget?.id;
    switch (id) {
      case 'visitType':
        setOpenPrescriptionModal(true);
        break;
      case 'rebookAppointment':
        rebookAppointment();
        break;
      case 'viewReceipt': {
        const paymentId = get(appointment, 'teleConsultSessionObject.payment.id', null);
        if (paymentId)
          dispatch(getReceipt(paymentId));
      }
        break;
      case 'joinCall':
        checkAndSetPermission().then(() => {
          dispatch(updateAgoraState({ teleConsultSessionId: get(appointment, 'teleConsultSessionObject.id', '') }));
        });
        break;
      case 'toCalendar':
        if (isPharmeasyIosWebview) {
          const calUrl = getCalenderUrl();
          const deeplink = `push.pharmeasy.clevertap://deeplink/open_url_in_browser?url=${calUrl}`;
          emitEvent('onAction', {
            deeplink,
          });
        } else {
          window.open(getCalenderUrl(), '_blank');
        }
        break;

      case 'reschedule':
        setOpenBookingModal(true);
        setIsReschedule(true);
        break;
      case 'cancelAppointment':
        setOpenCancelModal(true);
        break;
    }
  }

  function renderFooter() {
    const hasVisibility = some(shifts, ['visibility', 'on']);
    const isRebookEnable = hasVisibility && docShortUrl;

    return (
      <Footer hidden={isFetchingAppointment}>
        {
          visitID && appointmentStatus == 'completed' ? (
            <PrimaryButton
              id='visitType'
              title={visitType === 'prescription' ? 'View prescription' : 'View certificate'}
              onClick={handleClick}
            />
          ) : null
        }

        {
          isRebookEnable ? (
            <PrimaryButton
              id='rebookAppointment'
              title={'Rebook appointment'}
              className='greybtn capital'
              onClick={handleClick}
            />
          ) : null
        }

        {
          teleConsultSessionID != null && get(appointment, 'teleConsultSessionObject.payment.id') && appointmentStatus == 'completed' ? (
            <PrimaryButton
              id='viewReceipt'
              title='View Receipt'
              icon={isFetchingReceipt ? 'loading' : ''}
              onClick={handleClick}
            />
          ) : null
        }
      </Footer>
    );
  }

  function generateShareMsg() {
    if (isPastAppointment) return null;

    const shortUrl = token?.data?.shortUrl?.id;
    let msg = '';
    if (appointment.patientDetails) {
      msg = `CONFIRMED ${patientFullName} (${officeID}) appointment for `;
    } else {
      msg = `CONFIRMED ${tmpUserFullName} appointment for `;
    }

    msg = `${msg}
          ${moment(appointmentDate, 'YYYY-MM-DD HH:mm:ss ZZ').format('DD/MMM/YYYY')}
          ${moment().startOf('day').add(appointmentTime, 'minutes').format('hh:mm A')}
          with ${docFullName} at ${clinicName}, ${getAddressString(clinicAddress, true)}. Ph: ${clinicNumber}
           For Details ${shortUrl} Team DocOn!`;

    msg = 'https://api.whatsapp.com/send?text=' + encodeURI(msg);
    // console.log(appointment, msg);
    return msg;
  }

  const handleModalClose = (modal: string) => ({ fetchAppointment, isReschedule }: any = {}) => {
    switch (modal) {
      case 'prescription':
        return setOpenPrescriptionModal(false);
      case 'appointmentBooking':
        if (fetchAppointment)
          dispatch(getAppointment({ appointmentId }));
        if (isReschedule)
          triggerRescheduleEvent();
        setIsReschedule(false);
        return setOpenBookingModal(false);
      case 'cancelAppointment':
        return setOpenCancelModal(false);
      default:
        break;
    }
  };

  const handleCallClick = () => {
    if (isPharmeasyIosWebview) {
      const deeplink = `push.pharmeasy.clevertap://deeplink/open_dialer?phoneNumber=${clinicNumber}`;
      emitEvent('onAction', {
        deeplink,
      });
    } else {
      window.location.href = `tel:${clinicNumber}`;
    }
  };

  function triggerRescheduleEvent() {
    const appointmentTime = bookedAppointment?.appointment?.appointmentTime || bookedAppointment?.appointmentTime;
    cleverTapAnl.event({
      event_name: 'appointment_reschedule',
      event: {
        page_name: 'appointment_details',
        doctor_id: doctorID,
        slot_time: getTimeFromMinutes(appointmentTime),
        slot_type: appointment.isTeleConsult ? 'video' : 'physical',
        teleconsult_id: teleConsultSessionID || '-',
        appointment_id: appointmentId,
        appointment_status: appointmentStatus,
        appointment_date: moment(appointmentDate).format('YYYY-MM-DD'),
        patient_id: appointment.patientID,
        banner_id: '-',
        banner_label: '-',
        is_banner_active: '-',
        cta_label: 'Reschedule',
        appointment_help_sub_reason: '-',
        reschedule_time_to_appointment: timeDifferenceToAppointment,
        transaction_amount: appointment.teleConsultSessionObject?.pricing_details?.total || 0,
      },
    } as EventAppointmentReschedule);
  }
  const shareMsg = generateShareMsg();

  function renderContent() {

    if (!isEmpty(appointmentErrors)) {
      const errorMsg = Object.keys(appointmentErrors).map((key: string) => `${get(appointmentErrors, `${key}.messages[0]`, '')}`).join('\n');
      return (
        <AlertMsg
          type='error'
          message={errorMsg}
        />
      );
    }

    return (
      <>
        {
          isPastAppointment ? (
            <AppointmentCard
              hideFooter
              hideDelay
              type={'appointmentDetail'}
              appointment={appointment}
            />
          ) : null
        }

        <Content>
          <DocItem
            showRightArrow
            hidePic
            doctor={appointment.doctordetails}
            subTitle={clinicName}
            onClick={openDoctorProfile}
          />
          <FlexBox className='address'>
            <BaseBox flex={1}>
              <Heading3 title={address} />
              <GetDirection address={address} />
            </BaseBox>

            <Map
              lat={get(clinicAddress, 'location.coordinates.1')}
              lng={get(clinicAddress, 'location.coordinates.0')}
            />
          </FlexBox>

          {
            isPastAppointment ? null : (
              <>
                <FlexBox className='details'>
                  {
                    appointmentDelay ? <TimeIcon width={40} color={colors.success} /> : (
                      <CenterBox size={40} bg={'#5062ff'} borderRadius={'50%'}>
                        <Icons.TimerIcon width={25} color={colors.white} />
                      </CenterBox>
                    )
                  }

                  <BaseBox>
                    <Heading4 fontWeight={700} color='#120f3b'>
                      <BaseBox as='span' color={appointmentDelay ? '#0fa960' : ''}>{parseAppointmentTime}{appointmentTime ? ', ' : ''}</BaseBox>
                      {moment(appointmentDate, 'YYYY-MM-DD HH:mm:ss ZZ').format('DD MMMM')}
                    </Heading4>

                    {
                      appointmentDelay ? (
                        <Body2 title={`Doctor has delayed the appointment by ${delayTime}`} />
                      ) : null
                    }
                    {
                      patientFullName ? (
                        <Heading4 fontWeight={500}>
                          {patientFullName}
                          <BaseBox as='span' hidden={!officeID} >({officeID})</BaseBox>
                        </Heading4>
                      ) : (
                        <Heading3 title={userFullName} fontWeight={500} />
                      )
                    }
                  </BaseBox>
                </FlexBox>

                <FlexBox className='footerCard'>
                  {
                    clinicNumber ? (
                      <a onClick={handleCallClick}>
                        <Icons.PhoneIcon /> Call
                      </a>
                    ) : null
                  }
                  {
                    shareMsg ? (
                      <a
                        href={shareMsg}
                        data-action='share/whatsapp/share'
                        target='_blank' rel='noreferrer'
                      >
                        <Share /> SHARE
                      </a>
                    ) : null
                  }
                </FlexBox>
              </>
            )
          }
        </Content>

        {
          isPastAppointment ? renderFooter() : (

            <ActionLists tagAs='ul'>
              {
                (actionListsByStatus[appointmentStatus] || actionListsByStatus.notCancelled).map(({ Icon, ...list }: any) => (
                  <Heading3
                    key={list.id}
                    tagAs='li'
                    id={list.id}
                    hidden={list.checkKey && !appointment[list.checkKey]}
                    color={list.color || 'currentColor'}
                    title={<><Icon height={22} /> {list.label}</>}
                    onClick={handleClick}
                  />
                ))
              }
            </ActionLists>
          )
        }
      </>
    );

  }

  return (
    <>
      <Modal
        centered
        hideFooter
        isOpen
        title={'Appointment details'}
        onClose={onClose}
        {...props}
      >
        {
          showPermissionErrorToast && <AlertMsg type='error' message={'Camera and Microphone Permissions Denied'} />
        }
        {
          isFetchingAppointment ? <Loader /> : renderContent()
        }

        {
          visitID ? (
            <OrderMedicine
              visitID={visitID}
              source={source}
              patientID={appointment.patientID}
              doctorID={doctorID}
              mobileNumber={pMobileNumber}
            />
          ) : null
        }
      </Modal>

      {
        openPrescriptionModal ? (
          <PrescriptionModal
            hideOrderMedicine
            visitID={visitID}
            doctorID={doctorID}
            mobileNumber={pMobileNumber}
            onClose={handleModalClose('prescription')}
          />
        ) : null
      }

      {
        openBookingModal ? (
          <BookingModal
            isOpen
            isReschedule={isReschedule}
            appointment={isReschedule ? appointment : {}}
            doctor={{ ...appointment.doctordetails, clinicID }}
            onClose={handleModalClose('appointmentBooking')}
          />
        ) : null
      }

      <CancelAppointment
        isOpen={openCancelModal}
        appointment={appointment}
        onClose={handleModalClose('cancelAppointment')}
      />
    </>
  );
}

export default styled(withRouter(AppointmentDetails))``;